module.exports = __webpack_public_path__ + "img/button_left.a5ef6888.svg";